import * as React from "react";
import { connect } from "react-redux";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import * as msgs from "../../constants/textConstants";
import * as types from "../../constants/actionTypes";
import { getFirstName, firstNameFirst, getInitials } from "../../helpers/formatting";
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { Typography } from '../ecosystem/foundation';


class ActiveUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dropdownOpen: false };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ActiveUser.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let { loginStatus, primaryUser, currentMyChartUser, currentPharmacyUser, onLogoutClick, mobileView, containerClass, dateTimeOffset, bundle, patientPhoto } = this.props;
        let greetingText = '';
        let proxyText = '';
        let displayName = '';
        let mainClass = containerClass ? containerClass : '';
        let activeUser = null;


        try {

            if (primaryUser) {

                try {
                    // Stinky poopoo javascript dates!
                    const thisStartDate = new Date();
                    const thisUTCDate = new Date(Date.parse(thisStartDate.toUTCString()) - (dateTimeOffset * 60000));
                    const hour = thisUTCDate.getUTCHours();
                    const pathname = (typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "");
                    const onPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
                    //debugger;
                    displayName = getFirstName(primaryUser.displayName);
                    greetingText = hour < 12 ? 'Good morning,' : (hour < 18 ? 'Good afternoon,' : 'Good evening,');
                    if (!onPharmacy && primaryUser && currentMyChartUser && (//currentMyChartUser.externalId === null ||                
                        (primaryUser.externalId && currentMyChartUser.externalId && currentMyChartUser.externalId !== primaryUser.externalId) ||
                        (primaryUser.myChartId && currentMyChartUser.myChartId && currentMyChartUser.myChartId.toLowerCase() !== primaryUser.myChartId.toLowerCase()))) {
                        activeUser = currentMyChartUser;
                        proxyText = <div className="proxy-name">Viewing {activeUser.firstName ? activeUser.firstName : getFirstName(activeUser.displayName)}</div>;
                    }
                    else if (onPharmacy && currentPharmacyUser) {
                        activeUser = currentPharmacyUser;
                        proxyText = <div className="proxy-name">Viewing {activeUser.firstName}</div>;
                    }
                    else {
                        activeUser = primaryUser;
                    }

                }
                catch (EE) {
                    //debugger;
                    throw EE;
                }
            }


            return (
                <div className={"row " + mainClass}>
                    {loginStatus === types.USER_AUTHENTICATE || loginStatus === types.LOGOUT ||
                        (loginStatus === types.USER_AUTHENTICATE_SUCCESS && !displayName)
                        ? <MiniSpinner />
                        : <div className="col-12">
                            {mobileView
                                ? <div className="row">
                                    <div className="col-6 truncate">
                                        <span className="header__greeting--text">{greetingText}</span>
                                        <span className="header__greeting--user"> {displayName}</span>
                                    </div>
                                    <div className="col-6 truncate">
                                        <span className="header__greeting--proxy">{proxyText}</span>
                                    </div>
                                </div>
                                : <div>
                                    <div className="header__users--current">
                                        {/* <Dropdown
                                            isOpen={this.state.dropdownOpen}
                                            toggle={() => this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }))}
                                        >
                                            <DropdownToggle caret>*/}
                                        <div className="header__greeting align-items-center">
                                            {/*<span className="header__greeting--text">{greetingText}</span>{' '}*/}
                                            <Typography
                                                bold={true}
                                                color="$color-primary-a2"
                                                type="body-02"
                                            >{firstNameFirst(displayName)}
                                               
                                            </Typography>
                                                    
                                            {proxyText && <span className="header__greeting--proxy">{proxyText}</span>}
                                        </div>
                                           {/* </DropdownToggle>*/}
                                            {/*<DropdownMenu>
                                                <DropdownItem divider />
                                                <DropdownItem className="logout-btn" disabled={loginStatus === types.LOGOUT} onClick={onLogoutClick}>
                                                    Log Out
                                            </DropdownItem>
                                            </DropdownMenu>*/}
                                        {/*</Dropdown>*/}
                                    </div>
                                    <div className="header__users--selected">
                                        <button className="user-avatar selected-user">
                                            {activeUser &&
                                                <div className="user-avatar__btn" style={{ backgroundImage: patientPhoto ? `url(data:image/png;base64,${patientPhoto})` : '' }}>
                                                    {!patientPhoto && (activeUser.displayName
                                                        ? getInitials(activeUser.displayName)
                                                        : activeUser.firstName[0].toUpperCase() + activeUser.lastName[0].toUpperCase()
                                                    )}
                                                </div>
                                            }
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            );
        }
        catch (E) {
            //debugger;
            throw E;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        loginStatus: state.domain.ls,
        dateTimeOffset: state.domain.dto,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActiveUser);